module.exports = __webpack_public_path__ + "static/media/Finger ring.36323b74.png";